<div class="today spacing--margin-vertical spacing--padding-top">
  <h1 class="text--h1">{{ greeting$ | async }} {{ customer$ | async }}</h1>
  <p class="today__summary text--light flex">
    {{ 'dashboard.today.today-is' | translate }} {{ now$ | async | agrDate: 'longDate' }}.
  </p>
</div>
